import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import SharedProviders_0_0 from './extensions/38d892f6b9549b717359a5ac10149c5fa656ecf72d7339822658895635cf490c/providers';


@NgModule({
    imports: [CommonModule, ],
    providers: [...SharedProviders_0_0],
})
export class SharedExtensionsModule {}
